'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useReducedMotion } from 'motion/react';
export interface ShouldShowGame {
  ready: boolean;
  show: boolean;
}
const SIZE_QUERY = '(min-width: 768px)';
export function useShouldShowGame() {
  const $ = _c(5);
  const [ready, setReady] = useState(false);
  const [isWide, setIsWide] = useState(false);
  const reducedMotion = useReducedMotion();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const mq = window.matchMedia(SIZE_QUERY);
      const update = () => setIsWide(mq.matches);
      update();
      setReady(true);
      mq.addEventListener("change", update);
      return () => mq.removeEventListener("change", update);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const t2 = ready && isWide && !reducedMotion;
  let t3;
  if ($[2] !== ready || $[3] !== t2) {
    t3 = {
      ready,
      show: t2
    };
    $[2] = ready;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}